"use client";

import { c as _c } from "react-compiler-runtime";
import { Check, Circle } from "lucide-react";
import { motion } from "motion/react";
import { Text } from "@/components/primitives";
import { useTranslation } from "@/core/i18n";
import type { ChecklistStep } from "./types";
type ChecklistStepsPanelProps = {
  steps: ChecklistStep[];
  activeStepIndex: number;
};
export default function ChecklistStepsPanel(t0) {
  const $ = _c(11);
  const {
    steps,
    activeStepIndex
  } = t0;
  const {
    t
  } = useTranslation();
  let t1;
  let t2;
  if ($[0] !== activeStepIndex || $[1] !== steps || $[2] !== t) {
    const visibleSteps = steps.slice(0, Math.min(steps.length, activeStepIndex + 1));
    t1 = "w-full space-y-3";
    let t3;
    if ($[5] !== activeStepIndex || $[6] !== t) {
      t3 = (step, idx) => {
        const isCompleted = idx < activeStepIndex;
        const isActive = idx === activeStepIndex;
        return <motion.div animate={{
          opacity: 1,
          x: 0
        }} className="flex items-center gap-2.5" initial={{
          opacity: 0,
          x: -8
        }} key={step.id} transition={{
          duration: 0.25,
          delay: idx * 0.05
        }}><div className={`flex h-5 w-5 shrink-0 items-center justify-center rounded-full transition-colors ${isCompleted ? "text-smoked-stone" : isActive ? "bg-stone text-stone" : "border-smoked-stone text-smoked-stone border"}`}>{isCompleted ? <Check className="h-3.5 w-3.5" /> : isActive ? <Circle className="text-champagne-white h-2 w-2 fill-current" /> : <Circle className="h-2 w-2" />}</div><Text component="p" text={t(step.titleKey)} tone={isActive ? undefined : "muted"} variant="body-sm" /></motion.div>;
      };
      $[5] = activeStepIndex;
      $[6] = t;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    t2 = visibleSteps.map(t3);
    $[0] = activeStepIndex;
    $[1] = steps;
    $[2] = t;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  let t3;
  if ($[8] !== t1 || $[9] !== t2) {
    t3 = <div className={t1}>{t2}</div>;
    $[8] = t1;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
}